import { Component, ViewContainerRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GeographyMasterService } from '../geography_master.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

@Component({
    selector: 'config-department',
    templateUrl: './department.component.html',
    styleUrls: ['../geography_master.css']
})
export class configDepartment {

    collectionDetails = [];
    searchDataPafing = [];

    indexStart = 0;
    indexEnd = 10;
    pageSize = 5;
    pageNo = 1;
    totalPage = [1];

    searchInput = '';
    IsRecordUpdated = false;

    branchName = '';
    Acronym = '';
    DepartmentName = '';
    departmentCode = '';
    lastModifiedBy ='';
    lastModifiedDate ='';

    ButtonValue = 'Save';
    viewMode = false;
    CreatedBy = '';
    IsDeleting = false;
    DeletedIndex = '';
    createdDate = '';
    country: any;
    DepartmentTypeId = '';
    city = [];
    area = [];
    Id = '';
    addressLine1 = '';
    addressLine2 = '';

    cityArray = [];


    branchAreaMapping = [];


    constructor(private router: Router,
        public toastr: ToastsManager, vcr: ViewContainerRef,
        private PaymentService: GeographyMasterService,
        private fb: FormBuilder) {

        this.toastr.setRootViewContainerRef(vcr);
        this.PaymentService.GetDepartmentTypes()
            .subscribe(departmentListData => {
                this.cityArray = departmentListData;
            });






        this.PaymentService.GetDepartmentList('')
            .subscribe(departmentListData => {
                this.collectionDetails = [];
                this.searchDataPafing = [];
                this.collectionDetails = departmentListData;
                if (this.collectionDetails.length > 5) {
                    let j = 1;
                    for (var i = 0; i < this.collectionDetails.length; i++) {
                        i = i + this.pageSize;
                        j = j + 1;
                        this.totalPage.push(j);
                    }
                }
                for (var i = 0; i < this.collectionDetails.length; i++) {
                    let arr = [];
                    arr = this.collectionDetails[i];
                    let rowNum = i;
                    this.searchDataPafing.push({ arr, "row": rowNum });
                }
                this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
                this.indexEnd = (this.pageNo * this.pageSize);
            });
    }




    pagingAgent(data) {
        this.pageNo = data;
        this.indexStart = (this.pageNo - 1) * this.pageSize + 1;
        this.indexEnd = (this.pageNo) * this.pageSize;
    }

    changeItemsPerPage(data) {
        if (this.collectionDetails.length > 0) {
            this.totalPage = [1]
            let j = 1;
            for (var i = 0; i < this.collectionDetails.length; i++) {
                i = i + this.pageSize;
                j = j + 1;
                this.totalPage.push(j);
            }
        }
        else {
            this.totalPage = [];
        }
        this.pageSize = data;
        this.indexStart = 0;
        this.indexEnd = this.pageSize;
    }

    searchInputFunction() {
        this.PaymentService.GetDepartmentList(this.searchInput)
            .subscribe(departmentListData => {
                this.collectionDetails = [];
                this.searchDataPafing = [];
                this.collectionDetails = departmentListData;
                console.log("data", departmentListData);
                if (this.collectionDetails.length > 5) {
                    let j = 1;
                    for (var i = 0; i < this.collectionDetails.length; i++) {
                        i = i + this.pageSize;
                        j = j + 1;
                        this.totalPage.push(j);
                    }
                }
                for (var i = 0; i < this.collectionDetails.length; i++) {
                    let arr = [];
                    arr = this.collectionDetails[i];
                    let rowNum = i;
                    this.searchDataPafing.push({ arr, "row": rowNum });
                }
                this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
                this.indexEnd = (this.pageNo * this.pageSize);
            });
    }

    UpdateRecordsPopulate(obj) {
        this.viewMode = false;
        this.ButtonValue = 'Update';

        this.Acronym = obj["acronym"];
        this.DepartmentName = obj["name"];
        this.DepartmentTypeId = obj["departmentTypeId"];
        this.createdDate = obj['createdDate'];
        this.departmentCode = obj['code'];
        this.CreatedBy = obj['createdBy'];
        this.Id = obj['id'];
        this.lastModifiedBy = obj["lastModifiedBy"];
        this.lastModifiedDate = obj["lastModifiedDate"];
    }

    ViewRecordsPopulate(obj) {
        this.viewMode = true;
        this.IsRecordUpdated = true;
        this.ButtonValue = 'Save';
        this.Acronym = obj["acronym"];
        this.DepartmentName = obj["name"];
        this.DepartmentTypeId = obj["departmentTypeId"];
        this.createdDate = obj['createdDate'];
        this.departmentCode = obj['code'];
        this.Id = obj['id'];
    }

    reset() {
        this.viewMode = false;
        this.Acronym = '';
        this.DepartmentName = '';
        this.DepartmentTypeId = '';
        this.createdDate = '';
        this.departmentCode = '';
    }

    memberFormSubmit() {
        if (this.Id != '') {
            let selectedAreaIds = [];
            let selectedAreaNames = [];
            let data = {
                "acronym": this.Acronym,
                "code": this.departmentCode,
                "createdBy": this.CreatedBy,
                "createdDate": this.createdDate,
                "departmentType": "",
                "departmentTypeId": this.DepartmentTypeId,
                'id': this.Id,
                'lastModifiedBy': this.lastModifiedBy,
                "lastModifiedDate": this.lastModifiedDate,
                "name": this.DepartmentName
            }
            this.PaymentService.EditDepartment(data)
                .subscribe(departmentListData => {
                    if (departmentListData == "Success") {
                        this.toastr.success("Record updated succesfuly.");
                        this.LoadGrid();
                    }
                    else {
                        this.toastr.error("Area Name and Code already exists.");
                    }
                });
        }
        else {

            let data = {
                "acronym": this.Acronym,
                "code": this.departmentCode,
                "createdBy": '',
                "createdDate": '',
                "departmentTypeId": this.DepartmentTypeId,
                "id": '',
                "lastModifiedBy": '',
                "lastModifiedDate": '',
                "name": this.DepartmentName,
                "trackingState": "2"
            }
            this.PaymentService.CreateDepartment(data)
                .subscribe(departmentListData => {
                    if (departmentListData == "Success") {
                        this.toastr.success("Record Added succesfuly.");
                        this.LoadGrid();
                    }
                    else {
                        this.toastr.error("City Name and Code already exists.");
                    }
                });
        }
    }

    codegen() {
        let str = this.DepartmentName;
        this.PaymentService.GeneratedAcronym(str)
            .subscribe(departmentListData => {
                this.Acronym = departmentListData;
            });
        this.PaymentService.GenerateDepartmentCode(str)
            .subscribe(departmentListData => {
                this.departmentCode = departmentListData;
            });
    }

    deleteProdutConfirm(id, i) {
        this.DepartmentTypeId = id;
        this.IsDeleting = true;
        this.DeletedIndex = i;
    }
    delete() {
        let data = {
            "id": this.DepartmentTypeId,
            "trackingState": this.DeletedIndex
        }
        // this.PaymentService.DeleteProductGroup(data)
        //     .subscribe(departmentListData => {

        //     });
    }
    deleteCancel() {
        this.IsDeleting = false;
        this.DepartmentTypeId = '';
        this.DeletedIndex = '';
    }

    LoadGrid() {
        this.PaymentService.GetDepartmentList(this.searchInput)
            .subscribe(departmentListData => {
                this.collectionDetails = [];
                this.searchDataPafing = [];
                this.collectionDetails = departmentListData;
                console.log("data", departmentListData);
                if (this.collectionDetails.length > 5) {
                    let j = 1;
                    for (var i = 0; i < this.collectionDetails.length; i++) {
                        i = i + this.pageSize;
                        j = j + 1;
                        this.totalPage.push(j);
                    }
                }
                for (var i = 0; i < this.collectionDetails.length; i++) {
                    let arr = [];
                    arr = this.collectionDetails[i];
                    let rowNum = i;
                    this.searchDataPafing.push({ arr, "row": rowNum });
                }
                this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
                this.indexEnd = (this.pageNo * this.pageSize);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/system_setting/geography_master/configure_department/department.component.ts